import { handleFormikValueChange, TextInput } from "lcm-iot-commons";

type Props = {
  valueArrayName: string;
  objIdx: number;
  values: {
    modbusConfig?: $TSFixMe;
  };
};

export function FieldGatewayModbusValueTextInput(props: Props) {
  const { valueArrayName, objIdx, values } = props;

  return (
    <TextInput
      {...props}
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      hideLabel
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      value={values[valueArrayName][objIdx].valueName}
      validateOnChange
      validateOnBlur
      errors={{}}
      handleChange={(value) => {
        handleFormikValueChange(props, value.target.value);
      }}
    />
  );
}

export default FieldGatewayModbusValueTextInput;
